<template>
  <main>
    <div class="container">
      <!-- 切換標題 -->
      <div class="tab_title" :class="{ jp: $region === 'jp' }">
        <router-link
          :to="{ name: 'news' }"
          class="cate news_title"
          :class="{ jp: $region === 'jp' }"
        >
          <p class="gray">{{ $t("active.newsNotice") }}</p>
        </router-link>
        <a class="cate event_title" :class="{ jp: $region === 'jp' }">
          <p>{{ $t("active.newActive") }}</p>
          <div class="focus_dot"></div>
        </a>
      </div>
      <!-- 活动timeline -->
      <div class="eventsline">
        <div class="event_item" v-for="n in eventList" :key="n.activity_id">
          <div
            class="img_box"
            :style="{ backgroundImage: 'url(' + n.image + ')' }"
          ></div>
          <div class="info_box">
            <h5 v-text="n.game_name"></h5>
            <h3 v-text="n.title"></h3>
            <p
              :class="{ 'info-p-jp': $region === 'jp' }"
              v-text="n.summary"
            ></p>
            <div class="info-bot" :class="{ jp: $region === 'jp' }">
              <div class="timeTip">
                <h6>{{ $t("active.activeTime") }}</h6>
                <p
                  v-text="getDate(n.begin_time) + ' - ' + getDate(n.end_time)"
                ></p>
              </div>
              <!-- :href="n.url||'/eventdetail#'+n.activity_id" -->
              <a
                @click="toDetail({ url: n.url, id: n.activity_id })"
                class="getDetail"
              >
                <span style="vertical-align: middle;">{{
                  $t("active.knowDetail")
                }}</span>
                <img
                  style="vertical-align: middle;"
                  class="img_g"
                  src="../../assets/images/news/arrow_right_circle.svg"
                  alt
                />
                <img
                  style="vertical-align: middle;"
                  class="img_w"
                  src="../../assets/images/news/arrow_right_circle_w.svg"
                  alt
                />
              </a>
            </div>
          </div>
        </div>
      </div>
      <!-- 查看更多 -->
      <div
        v-if="have_more"
        class="show_more"
        @click="getEvents"
        ga-data="302002"
      >
        {{ $t("active.checkMore") }}
        <span class="icon">
          <img src="../../assets/images/news/arrow_down_circle.svg" alt />
        </span>
      </div>
      <div v-else class="show_more gray">
        <span v-if="$region !== 'jp'">{{ $t("active.noMoreActive") }}</span>
      </div>
      <span
        class="toTop"
        v-if="scrollTopHigth > 600"
        @click="scrollsotp"
      ></span>
    </div>

    <!-- 回到顶部 -->
  </main>
</template>

<script>
export default {
  name: "active",
  data() {
    return {
      page_num: 1,
      eventList: [],
      have_more: true,
      totop: false,
      scrollTopHigth: 600,
    };
  },
  methods: {
    toDetail(param) {
      if (param.url) {
        window.location.href = param.url;
      } else {
        this.$router.push({ name: "activeDetail", params: { id: param.id } });
      }
    },
    // handleScroll() {
    //   if (
    //     self.pageYOffset ||
    //     document.documentElement.scrollTop ||
    //     document.body.scrollTop
    //   ) {
    //     this.totop = true;
    //   } else {
    //     this.totop = false;
    //   }
    // },
    getEvents() {
      this.$apis.home.getEventsList(this.page_num, 20).then((data) => {
        let res = data.data;
        // console.log(res)
        if (res.code == 0) {
          if (res.data.length > 0) {
            this.eventList.push(...res.data);
            this.page_num++;
          } else {
            this.have_more = false;
          }
        } else {
          //   console.error(res.message);
        }
      });
    },
    getDate(t) {
      let day = new Date(t).toLocaleDateString();
      return day;
    },
    scrollsotp() {
      const currentY =
        document.documentElement.scrollTop || document.body.scrollTop;
      this.scrollAnimation(currentY, 0);
    },
    scrollAnimation(currentY, targetY) {
      // 获取当前位置方法
      // 计算需要移动的距离
      let needScrollTop = targetY - currentY;
      let _currentY = currentY;
      setTimeout(() => {
        // 一次调用滑动帧数，每次调用会不一样
        const dist = Math.ceil(needScrollTop / 10);
        _currentY += dist;
        window.scrollTo(_currentY, currentY);
        // 如果移动幅度小于十个像素，直接移动，否则递归调用，实现动画效果
        if (needScrollTop > 10 || needScrollTop < -10) {
          this.scrollAnimation(_currentY, targetY);
        } else {
          window.scrollTo(_currentY, targetY);
        }
      }, 1);
    },
    listenerFunction() {
      document.addEventListener("scroll", this.handleScroll, true);
    },
    handleScroll() {
      let scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop;
      this.scrollTopHigth = scrollTop;
    },
  },
  mounted() {
    this.listenerFunction();
    // 请求活動
    this.getEvents();
    // window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.listenerFunction);
  },
};
</script>

<style lang="scss" scoped>
// 关于小萌，联系我们，会员规章
.contact-container {
  min-width: 1200px;
}
.main-block {
  width: 100%;
  max-width: 1200px;
  min-width: 1200px;
  margin: 0 auto;
  font-size: 20px;
}
.main-tit {
  height: 112px;
  padding-top: 80px;
  text-align: center;
  border-bottom: 1px solid #ccc;
  .tit-slice {
    width: 24px;
    height: 4px;
    background: #50bbe5;
    border-radius: 100px;
    vertical-align: middle;
  }
  .tit-en-des {
    font-size: 14px;
    color: #cccccc;
    letter-spacing: 0;
    line-height: 17px;
  }
  .tit-des {
    font-size: 32px;
    color: #444444;
    letter-spacing: 0;
  }
  span {
    display: inline-block;
  }
}
.main-con {
  .con-tit {
    padding-top: 61px;
    font-size: 24px;
    font-weight: bold;
    color: #50bbe5;
    line-height: 31px;
  }
  .con-block {
    padding-top: 30px;
    color: #444;
  }
  .con-about {
    font-size: 14px;
    line-height: 28px;
  }
}
div,
p,
h3,
h4,
h5,
h6,
span {
  margin: 0;
  padding: 0;
}
a {
  color: inherit;
  text-decoration: none;
}
main {
  min-width: 1366px;
}
.container {
  width: 1170px;
  margin: 0 auto;
  padding-top: 80px;
  box-sizing: border-box;
  min-height: calc(100vh - 242px);
  .tab_title {
    border-bottom: 1px solid #eeeeee;
    text-align: center;
    margin-bottom: 40px;
    &.jp {
      text-align: left;
      .cate {
        margin-right: 80px;
        p {
          font-size: 24px;
        }
        .focus_dot {
          height: 2px;
        }
      }
    }
    .cate {
      display: inline-block;
      width: 188px;
      position: relative;
      cursor: pointer;
      &.jp {
        width: auto;
      }
      p {
        font-size: 32px;
        color: #444444;
        margin-bottom: 24px;
        &.gray {
          color: #bdbdbd;
        }
      }
      .focus_dot {
        margin: 0 auto;
        width: 32px;
        height: 6px;
        border-radius: 3px;
        background: #50bbe5;
      }
    }
  }
  .eventsline {
    border-bottom: 1px solid #eeeeee;
    .event_item {
      display: flex;
      align-items: stretch;
      margin: 60px 0;
      .img_box {
        width: 480px;
        height: 270px;
        background-color: #444444;
        background-position: center center;
        background-size: cover;
        flex-grow: 0;
        flex-shrink: 0;
        margin-right: 30px;
        border-radius: 10px;
      }
      .info-bot {
        &.jp {
          display: flex;
          justify-content: space-between;
          .getDetail {
            position: relative;
            border-color: #ddd;
            &:hover {
              border-color: #50bbe5;
            }
          }
          .timeTip {
            p {
              margin-bottom: 0;
              height: 20px;
            }
          }
        }
      }
      .info_box {
        flex-grow: 1;
        position: relative;
        h5 {
          font-size: 14px;
          color: #999999;
          margin-bottom: 5px;
        }
        h3 {
          font-size: 20px;
          color: #444444;
          margin-bottom: 10px;
        }
        p {
          font-size: 16px;
          color: #999999;
          line-height: 24px;
          height: 72px;
          overflow: hidden;
          margin-bottom: 20px;
          &.info-p-jp {
            height: 154px;
          }
        }
        .getDetail {
          position: absolute;
          display: block;
          bottom: 0;
          left: 0;
          width: 170px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          border: 1px solid #50bbe5;
          border-radius: 20px;
          font-size: 14px;
          color: #333333;
          cursor: pointer;
          img {
            width: 12px;
            margin-left: 10px;
          }
          .img_g {
            display: inline-block;
          }
          .img_w {
            display: none;
          }
        }
        .timeTip {
          position: relative;
          padding-left: 14px;
          &::before {
            content: "";
            display: block;
            width: 4px;
            height: 40px;
            border-radius: 2px;
            background: #50bbe5;
            position: absolute;
            top: 0;
            left: 0;
          }
          h6 {
            font-size: 12px;
            color: #444444;
            line-height: 20px;
          }
          p {
            font-size: 16px;
            color: #444444;
            line-height: 20px;
          }
        }
      }
      .getDetail {
        &:hover {
          color: #fff;
          background: #50bbe5;
          .img_w {
            display: inline-block;
          }
          .img_g {
            display: none;
          }
        }
      }
      &:hover {
        .info_box {
          & > p,
          h3 {
            color: #50bbe5;
          }
        }
      }
    }
  }
  .show_more {
    text-align: center;
    font-size: 16px;
    line-height: 80px;
    color: #444444;
    padding-bottom: 120px;
    cursor: pointer;
    &.gray {
      color: #cccccc;
    }
    img {
      width: 12px;
    }
  }
  .toTop {
    display: block;
    position: fixed;
    width: 48px;
    height: 64px;
    left: 50%;
    bottom: 80px;
    margin-left: 615px;
    background: url(../../assets/images/news/totop_nor.svg) center center
      no-repeat;
    background-size: contain;
    &:hover {
      background-image: url(../../assets/images/news/totop_hover.svg);
    }
    &:active {
      background-image: url(../../assets/images/news/totop_pressed.svg);
    }
  }
}
</style>
